// removed by extract-text-webpack-plugin
module.exports = {"pending":"_3sb3YLaxZKZkrsJmLmIsy6","in_progress":"_1ZqRqQLUb8TvVOLFyGxbCD","on_hold":"jMeY5yvZTSOv3iiM5wKTl","cancelled":"_2_ZdAnjABaWokPVI4Ae9m6","completed":"_2j0K002WnD7iBuyXitDHvl","icon":"_3JpJC90703RvNpGz5F3c87"};


//////////////////
// WEBPACK FOOTER
// ./src/components/lotScheduleTransfers/styles.css
// module id = 1612
// module chunks = 0